<template>
    <a-modal
        :destroyOnClose="true"
        :footer="null" :maskClosable="false" :title="title"
        :width="width" v-bind="$attrs" v-model="show">
        <slot></slot>
    </a-modal>
</template>

<script>
    export default {
        name: "BaseModal",
        props: {
            width: {
                type: Number,
                default: 640
            },
            title: {
                type: String,
                required: true,
            },
        },
        computed: {
            show: {
                get() {
                    return this.$attrs.value;
                },
                set(value) {
                    this.$emit("input", value);
                }
            }
        },
    }
</script>
